import React from 'react'
import { StyledIcon } from '../StyledIcon'

// eslint-disable-next-line import/prefer-default-export
export const CouponError = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 24 24"
    a11yTitle={icon}
    color="plain"
    size={size}
    {...customProps}
  >
    <path d="M12 3C7.032 3 3 7.032 3 12C3 16.968 7.032 21 12 21C16.968 21 21 16.968 21 12C21 7.032 16.968 3 12 3ZM12.9 16.5H11.1V14.7H12.9V16.5ZM12.9 12.9H11.1V7.5H12.9V12.9Z" fill="#CC3333" />
  </StyledIcon>
)
